import styled from '../theme/styled-components';
import { SecondaryLinkExternal } from './Link';
import { Li, Ul } from './List';

export const ContactAddressUl = styled(Ul)``;
export const ContactAddressLi = styled(Li)`
  font-weight: ${props => props.theme.typography.body.fontWeight};
  font-size: ${props => props.theme.typography.body.fontSize};
  line-height: ${props => props.theme.typography.body.lineHeight};
`;

export const ContactAddress = styled.div`
  padding-bottom: ${props => props.theme.spacings.tiny};

  ${media => media.theme.media.greaterThan('small')`
    order: 0;
  `};
`;

export const ContactForm = styled.form`
  width: 100%;
  ${media => media.theme.media.greaterThan('medium')`
    padding-left: ${props => props.theme.spacings.large};
    padding-bottom: ${props => props.theme.spacings.large};
  `};
`;

export const ContactList = styled.div`
  width: 100%;
  ${media => media.theme.media.greaterThan('medium')`
    border: 1px solid ${props => props.theme.colors.border.dark.base};
    padding: ${props => props.theme.spacings.base}
  `};
`;

export const ContactFormHeader = styled.div``;
export const ContactFormHeaderH2 = styled.h2`
  margin-bottom: 0;

  ${SecondaryLinkExternal} {
    padding-left: ${props => props.theme.spacings.tiny};
  }
`;
